import type {
    ListBookingServicesResponse,
    BookingService as B2BookingService,
} from 'owa-graph-schema';
import type BookingService from 'owa-service/lib/contract/BookingService';
import mapB2BookingService from './mapB2BookingService';

const mapListBookingServicesResponse = (
    response: ListBookingServicesResponse,
    source?: string
): {
    services: BookingService[] | undefined;
} => {
    const mappedBookingServices = response.services?.map(bookingService =>
        mapB2BookingService(bookingService as B2BookingService, source)
    );
    const modifiedResponse = {
        services: mappedBookingServices as BookingService[] | undefined,
    };
    return modifiedResponse;
};

export default mapListBookingServicesResponse;
